/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { SelectCommand } from './select.command';

export function selectFactory() {
    const mapInteractions = inject(MapInteractionsService);
    const command = new SelectCommand();
    const dependencies = {'interactions': mapInteractions};
    command.setDependencies(dependencies);
    return command;
}
